import React, { useEffect, useState } from 'react';
import { Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { debug, swalAlert } from './../../utils'
import API from '../../api';
import PhoneNumber from '../helpers/PhoneNumber/PhoneNumber';
import { setUser } from './../../redux/userSlice';
import { BiShow, BiHide } from "react-icons/bi";
import PasswordChecker from './../helpers/PasswordChecker/PasswordChecker'
const UserSignUp = ({ onTabSwitch, options = null }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [signUpData, setSignUpData] = useState({
    userFirstname: '',
    userName: '',
    userEmail: '',
    userPhone: '',
    phoneNumber: '',
    password: ''
  });
  const [submission, setSubmission] = useState({ status: '', message: ' ' });
  const [loyaltyNumber, setLoyaltyNumber] = useState('0');
  const [inputType, setInputType] = useState('password');
  const [passwordIsValid, setPasswordIsValid] = useState(false);
  useEffect(() => {
    setSubmission({ status: '' });
  }, [signUpData]);
  const handleSignUpSubmit = async (event) => {
    setSubmission({ status: 'pending' });
    event.preventDefault();
    try {
      const data = { ...signUpData, ...options };
      const response = await API.post('/user/signUp', data);
      if (response.data.status === 'active') {


        localStorage.setItem('token', response.data.token);
        dispatch(setUser(response.data));
        onTabSwitch('close')
        swalAlert('Votre compte a été créé.');
        if (options?.onSigned) {
          navigate(options.onSigned)
        }




        if (options.onSigned) {
          navigate(options.onSigned)
        } else {

        }
        dispatch(setUser({ ...response.data, isSignedIn: true }));
        onTabSwitch('signIn')
      }
    } catch (error) {
      let errors = [];
      if (error.response.data.error.code === 400) {
        //   errors = JSON.parse(error.response.data.error.message);
      }
      setSubmission({ status: "error", code: error.response.data.error.code, message: error.response.data.error.message });
    }
  }
  return (
    <div className='user-form-container '>
      <Form onSubmit={(e) => { e.preventDefault() }}>
        <h1 className=''>Création de compte</h1>
        <Form.Group className="form-group mb-1 pb-0">
          <label className="form-group-label" required>Prénom : </label>
          <Form.Control
            type="text"
            size='sm'
            autoComplete="given-name"
            placeholder=""
            value={signUpData.userFirstname}
            onChange={(e) => { setSignUpData({ ...signUpData, userFirstname: e.target.value }); }}
            disabled={submission.status === 'pending'}
          />
        </Form.Group>
        <Form.Group className="form-group mb-1 pb-0">
          <label className="form-group-label" required>Nom : </label>
          <Form.Control
            type="text"
            size='sm'
            autoComplete="name"
            placeholder=""
            value={signUpData.userName}
            onChange={(e) => { setSignUpData({ ...signUpData, userName: e.target.value }); }}
            disabled={submission.status === 'pending'}
          />
        </Form.Group>
        <Form.Group className="form-group mb-1 pb-0">
          <label className="form-group-label" required>Email : </label>
          <Form.Control
            size='sm'
            type="text"
            name='userEmail'
            autoComplete="email"
            placeholder=""
            value={signUpData.userEmail}
            onChange={(e) => { setSignUpData({ ...signUpData, userEmail: e.target.value }); }}
            disabled={submission.status === 'pending'}
          />
        </Form.Group>
        <Form.Group className="form-group mb-1 pb-0">
          <label className="form-group-label" required>Téléphone : </label>
          <PhoneNumber number={signUpData.userPhone} onUpdate={(phoneNumber) => { setSignUpData({ ...signUpData, userPhone: phoneNumber }); }}
          />
        </Form.Group>
        <Form.Group className="form-group mb-1 pb-0">
          <label className="form-group-label" required>Mot de passe : </label>
          <InputGroup className='mb-1'>
            <Form.Control
              type={inputType}
              size='sm'
              value={signUpData.password}
              onChange={(e) => { setSignUpData({ ...signUpData, password: e.target.value }); }}
              disabled={submission.status === 'pending'}
            />
            <Button size='sm' variant="outline-secondary" onClick={() => { setInputType(inputType === 'password' ? 'text' : 'password') }}>
              {inputType === 'password' ? <BiShow /> : <BiHide />}
            </Button>
          </InputGroup>
          <PasswordChecker password={signUpData.password} isValid={v => setPasswordIsValid(v)} />
        </Form.Group>
        <Form.Group className="text-left mb-3">
          <label className='form-group-label'>
            Avez-vous une carte de fidélité de l'Affaire à Repasser :
          </label> <br />
          <label className="checkbox-label me-5">
            <input type="radio" value="true" checked={loyaltyNumber === '0'} onChange={e => { setLoyaltyNumber('0'); setSignUpData({ ...signUpData, custLoyaltyNumber: '' }) }} /> Non
          </label>
          <label className="checkbox-label">
            <input type="radio" value="true" checked={loyaltyNumber === '1'} onChange={e => setLoyaltyNumber('1')} />Oui
          </label>

          {loyaltyNumber === '1' && <Form.Control
            size='sm'
            type="number"
            name='custLoyaltyNumber'
            autoComplete="off"
            className="text-start"

            placeholder="Numéro de carte indiqué sous le qr-code de votre carte"
            value={signUpData.custLoyaltyNumber}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 6) {
                setSignUpData({ ...signUpData, custLoyaltyNumber: value });
              }
            }}
            disabled={submission.status === 'pending'}
          />}
        </Form.Group>




        <Form.Group className="text-center">
          <Alert
            className='py-2 px-3 small'
            variant={submission.status === 'success' ? 'success' : 'danger'}
            dismissible={true}
            transition={true}
            show={submission.status === 'error'}
            onClose={() => setSubmission({ status: '' })}
          >
            {t(submission.message)}
          </Alert>
        </Form.Group>



        <Form.Group className="form-group-submit">
          <Button variant="brand-primary" type="button" disabled={submission.status === 'pending' || submission.status === 'success'} onClick={handleSignUpSubmit}>
            Je crée mon compte
          </Button>
        </Form.Group>

      </Form>

      <p className='small pt-4 pb-3'>
        {(submission.code && submission.code === 409) &&
          <strong className='pointer d-block pb-3' onClick={e => onTabSwitch('lostPwd')}>Demander un nouveau mot de passe</strong>
        }
        <span className=' d-block pointer' onClick={e => onTabSwitch('')}>Connexion</span>

      </p>
    </div >
  );
}
export default UserSignUp;

